<template>
    <q-page class="column">
      <storage-tree :app-id="$route.params.app_id" :module-id="$route.params.module_id" block_id="app-storage" :key="$route.params.module_id"/>
    </q-page>
</template>

<script>

import StorageTree from "@/pages/workspace/storage/StorageTree.vue";

export default {
  name: "StorageTreePage",
  components: {StorageTree},
  data: () => ({
    systemSettings: [{

    }]
  }),
}

</script>
